import styled from 'styled-components';

const SActionIcon = styled.button`
  align-items: center;
  background: transparent;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.senaryText};
  cursor: pointer;
  display: flex;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;

  path {
    fill: ${({ theme }) => theme.colors.primaryText};
  }

  &:focus {
    outline-color: ${({ theme }) => theme.colors.primaryText};
  }

  &.medium {
    height: 3.125rem;
    width: 3.125rem;
  }

  &.large {
    height: 4.063rem;
    width: 4.063rem;
  }

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.secondaryText};
  }

  &:active {
    border: 2px solid ${({ theme }) => theme.colors.quaternaryText};
  }

  &.disabled {
    border: 1px solid ${({ theme }) => theme.colors.quaternaryText};

    path {
      fill: ${({ theme }) => theme.colors.quaternaryText};
    }
  }

  &.secondary {
    background: ${({ theme }) => theme.colors.quaternaryBackground};
    border: none;

    &:hover {
      background: ${({ theme }) => theme.colors.quaternaryText};
    }

    &:active {
      background: ${({ theme }) => theme.colors.primaryBackground};
    }

    &.disabled {
      background: ${({ theme }) => theme.colors.senaryBackground};
    }
  }

  &.tertiary {
    &:hover {
      background: ${({ theme }) => theme.colors.tertiaryBackground};
      border: none;
    }

    &:active {
      background: ${({ theme }) => theme.colors.primaryBackground};
      border: none;
    }
  }

  &.white {
    border: 1px solid ${({ theme }) => theme.colors.tertiaryText};

    path {
      fill: ${({ theme }) => theme.colors.secondaryBackground};
    }

    &:hover {
      border: 2px solid ${({ theme }) => theme.colors.senaryText};
    }

    &:active {
      border: 2px solid ${({ theme }) => theme.colors.tertiaryBackground};
    }

    &.disabled {
      border: 1px solid ${({ theme }) => theme.colors.tertiaryText};

      path {
        fill: ${({ theme }) => theme.colors.tertiaryText};
      }
    }
  }

  &.minimal {
    background: transparent;
    border: none !important;
    transition: opacity 0.3s linear;

    &:hover {
      opacity: 0.5;
    }
  }
`;

export default SActionIcon;
